import { useContext, useState } from "react"

import { useQuery } from "@apollo/client"
import { Calendar } from "primereact/calendar"
import DateFilterTemplate from "../../components/ReusableComponents/DateFilterTemplate"
// queries
import { SUPERVISION_SESSION } from "./queries"
import _ from "lodash"
import StaffSidebar from "../../components/StaffSidebar"
import { SplitButton } from "primereact/splitbutton"
import { useNavigate } from "react-router-dom"

// Context
import { UserContext } from "../../context/userContext"
import { parseDate } from "../../helpers/dateNormalization"
import dataParser from "../../helpers/parseJsonData"

import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"

import LoaderFullPage from "../../components/Loaders"

import styles from "../../styles/Page-Engagements.module.css"
import { navigateWithOrigin } from "../../helpers/navigation"

export default function SupervisionPlan() {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState(null)
  const userCtx = useContext(UserContext)
  const navigate = useNavigate()

  const ID_TEMPLATE = "individual_supervision_session"

  useQuery(SUPERVISION_SESSION, {
    variables: {
      staff_id: userCtx.session.user.staff_id,
      idTemplate: ID_TEMPLATE,
    },
    fetchPolicy: "no-cache",
    skip: !userCtx.session.user.staff_id,
    onCompleted: async (data) => {
      if (data.engagements === null) {
        return setLoading(false)
      }
      const dataFormatted = dataParser(data.engagements.data)
      const handleData = () =>
        _.map(dataFormatted, (row) => {
          const handleLocations = () => {
            const locationsList = _.map(
              row.session__location_ids,
              ({ label }) => label
            )
            return _.join(locationsList, ", ")
          }
          return {
            date: parseDate(row.session_date),
            locations: handleLocations(),
            length: `${row.session_length} minutes`,
            channel: row.session_channel,
            edit: (
              <SplitButton
                label="View"
                to={`/form/${ID_TEMPLATE}/1/${row.idStamp}`}
                onClick={() => {
                  userCtx.changeParticipant(undefined)
                  navigateWithOrigin(
                    navigate,
                    `/form/view/${ID_TEMPLATE}/${row.idStamp}`
                  )
                }}
                model={[
                  {
                    label: "Edit",
                    command: () => {
                      navigate(`/form/${ID_TEMPLATE}/1/${row.idStamp}`)
                    },
                  },
                ]}
              />
            ),
            facilitating_staff: row.staff_id,
            recovery_capital: "N/A",
            referral_made: "N/A",
            supervision_session_topic: row.supervision_session_topic.join(", "),
            supervision_session_plan_change:
              row.supervision_session_plan_change,
          }
        })
      setData(handleData())

      console.log(dataFormatted)
      setLoading(false)
    },
  })

  const dateBodyTemplate = (rowData) => {
    return formatDate(rowData.date)
  }

  const formatDate = (value) => {
    return value.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    })
  }

  if (loading) return <LoaderFullPage />

  return (
    <div className="layout-with-sidebar">
      <div className="sidebar">
        <StaffSidebar />
      </div>
      <div className="main-content">
        <div>
          <div>
            <h1 className={styles.title}>Supervision Sessions</h1>

            <div>
              {
                // {" "}              <Link to="/form/individual_supervision_session/1" className="btn">                {" "}                New Supervision Session{" "}              </Link>{" "}
              }
            </div>

            <br></br>
            <div className={styles.summaryTop}>
              <div>
                <h3>Supervision Frequency</h3>
                <span>N/A</span>
              </div>
            </div>

            <div className={styles.summaryTop}>
              <div>
                <h3>Primary Supervisor</h3>
                <span>N/A</span>
              </div>
            </div>
            <br />
            <br />
            <DataTable
              value={data}
              responsiveLayout="scroll"
              sortField="date"
              sortOrder={-1}
            >
              <Column
                field="date"
                sortable
                header="Date"
                filterField="date"
                dataType="date"
                filter
                filterElement={(options) => (
                  <DateFilterTemplate
                    value={options.value}
                    filterCallback={options.filterCallback}
                    index={options.index}
                  />
                )}
                body={dateBodyTemplate}
              />
              <Column field="locations" header="Locations" />
              <Column field="length" header="Length" />
              <Column field="supervision_session_topic" header="Topics" />
              <Column
                field="supervision_session_plan_change"
                header="Plan Changed"
              />
              <Column field="recovery_capital" header="Supervisor" />
              <Column field="edit" header="Actions" />
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  )
}
